export default "__VITE_ASSET__BjswLctC__"